import { render } from "./CancelActivityPopup.vue?vue&type=template&id=2a9c2547&scoped=true"
import script from "./CancelActivityPopup.vue?vue&type=script&lang=js"
export * from "./CancelActivityPopup.vue?vue&type=script&lang=js"

import "./CancelActivityPopup.vue?vue&type=style&index=0&id=2a9c2547&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9c2547"]])

export default __exports__